import loadable from '@loadable/component';

export { STATE_NAME } from './constants';

export default loadable(() =>
  import(/* webpackChunkName: "Alertbar" */ './containers/Alertbar'),
);

export { default as reducer } from './reducer';
